import { Grid, Checkbox, Box } from '@mui/material'
import FormControlLabel from '@mui/material/FormControlLabel';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { AI_BLUE, aiIconSx } from '../styles/CommonStyles';

const styles = {
    customFieldsBox: {
        backgroundColor: 'var(--spectre-surface)',
        textArea: {
            color: '#636383'
        },
        mt: 1
    },
    populatedBox: {
        border: '2px solid transparent',
        backgroundImage: 'linear-gradient(white, white), linear-gradient(90deg, #00004B, #F7914B, #00004B)',
        backgroundOrigin: 'border-box',
        backgroundClip: 'padding-box, border-box',
        backgroundSize: '100% 100%, 200% 100%',
        borderRadius: 1,
        px: 1,
        display: 'flex',
        alignItems: 'center',
        width: 'fit-content',
        ml: -1 // Shift slightly to align with other fields
    }
}

export default function CustomFieldCheckBox(props: any) {
    const { index, customField, updateCustomFieldSubmitValues, customFieldSubmitValues, isAiPopulated } = props
    const toggleColor = 'var(--spectre-custom-field-label)';

    const content = (
        <FormControlLabel
            style={{ float: "left", color: isAiPopulated ? AI_BLUE : toggleColor }}
            control={
                <Checkbox
                    sx={isAiPopulated ? { color: AI_BLUE, '&.Mui-checked': { color: AI_BLUE } } : { color: toggleColor, '&.Mui-checked': { color: toggleColor } }}
                    checked={customFieldSubmitValues['CustomFields']['Field'][index]['Value']}
                />
            }
            label={
                <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    {customField.name}
                    {isAiPopulated && <AutoAwesomeIcon sx={aiIconSx} fontSize="small" />}
                </span>
            }
            onChange={(element: any) => {
                updateCustomFieldSubmitValues(index, element.target.checked)
            }} />
    );

    return (
        <Grid item md={11} xs={11}>
            {isAiPopulated ? (
                <Box sx={styles.populatedBox}>
                    {content}
                </Box>
            ) : content}
        </Grid>
    );
}